import { render, staticRenderFns } from "./manageUser.vue?vue&type=template&id=2c2dc34d&"
import script from "./manageUser.js?vue&type=script&lang=js&"
export * from "./manageUser.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports